import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'answers'
})
export class AnswersPipe implements PipeTransform {

  transform(value: any, arg: any): unknown {
    let response = [];
    let i = 0;
    value.map(
      x=>{
        if (i>arg*100&&i<(arg+1)*100){
          response.push(x);
        }
      }
    )
    return response;
  }

}
